import Label from 'Components/Label';
import { useEffect, useState } from 'react';
import moment from 'moment';
import Button from 'Components/Button';
import Paginador from 'Components/Paginador';
import ProgressBar from 'Components/ProgressBar';
import NotificacionesService from 'Services/Http/Notificaciones.service';
import { useSelector } from 'react-redux';

const ListarNotificacionesUsuarioComponente = () => {
  const [otps, setOtps] = useState([]);
  const [loader, setLoader] = useState(false);
  const { id, title, descripcion } = useSelector((state) => state.notificacion.notificacion);
  useEffect(() => {
    getlastOtps();
  }, []);

  const getlastOtps = async () => {
    setLoader(true);
    setOtps([]);
    const response = await NotificacionesService.lectura(id);
    createRows(response.data);
    setLoader(false);
  };

  const createRows = (rows) => {
    let data = rows.map((item, index) => (
      <tr
        key={'otps-row-' + index}
        className="odd:bg-white even:bg-blue-100 border-b hover:bg-blue-300 hover:cursor-pointer">
        <td className="px-6 py-4">{item.idUsuario}</td>
        <td className="px-6 py-4">{item.nombre + ' ' + item.paterno + ' ' + item.materno}</td>
        <td className="px-6 py-4">
          {moment(item.created_at).utc().format('DD/MM/YYYY hh:mm:ss a')}
        </td>
      </tr>
    ));
    setOtps(data);
  };
  const refresh = () => {
    getlastOtps();
  };
  return (
    <>
      <Label text={'Lista de Alertas'} />
      <div className="flex flex-col grid grid-cols-1 md:grid md:grid-flow-col md:grid-cols-2 md:flex-row gap-3 my-3 justify-stretch">
        <div className="flex order-2 md:order-1">
          <Button iconprefix={['fa', 'rotate']} onClick={() => refresh()} />
        </div>
      </div>
      <div className="flex flex-col grid grid-cols-1 md:grid md:grid-flow-col md:grid-cols-2 md:flex-row gap-3 my-3 justify-stretch">
        <div className="flex order-2 md:order-1">Titulo: {title}</div>
      </div>
      <div className="flex flex-col grid grid-cols-1 md:grid md:grid-flow-col md:grid-cols-2 md:flex-row gap-3 my-3 justify-stretch">
        <div className="flex order-2 md:order-1">Mensaje: {descripcion}</div>
      </div>
      <div className="relative overflow-x-auto shadow-md sm:rounded-lg xl:w-1/2">
        <table className="w-full text-sm text-left rtl:text-right text-black">
          <thead className="text-xs text-white uppercase bg-blue-500">
            <tr>
              <th scope="col" className="px-6 py-3">
                #
              </th>
              <th scope="col" className="px-6 py-3">
                Nombre
              </th>
              <th scope="col" className="px-6 py-3">
                Fecha de lectura
              </th>
            </tr>
          </thead>
          <tbody>{otps}</tbody>
          <tfoot>
            <tr>
              <td colSpan={8}>
                <Paginador onChange={getlastOtps} />
              </td>
            </tr>
          </tfoot>
        </table>
        {loader ? <ProgressBar /> : ''}
      </div>
    </>
  );
};

export default ListarNotificacionesUsuarioComponente;
